import { EventOutlined, FactCheckOutlined, Inventory2Outlined, PaymentOutlined, PhoneAndroidOutlined, ReceiptLongOutlined, RestaurantOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { PASOS } from "../utils";

const iconos = { datos: EventOutlined, productos: Inventory2Outlined, menu: RestaurantOutlined, cobro: PaymentOutlined, facturacion: ReceiptLongOutlined, autogestion: PhoneAndroidOutlined, revision: FactCheckOutlined };

export default function CabeceraPasoEvento({ paso, acciones, titulo, ayuda, mostrarNumero = true }) {
  const actual = PASOS[paso];
  const Icono = iconos[actual.id] || EventOutlined;
  return (
    <Box sx={{ mb: 2 }}>
      {mostrarNumero && <Typography sx={{ color: "#777B9E", fontSize: 10, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", mb: 1 }}>Paso {paso + 1} de {PASOS.length}</Typography>}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={{ display: "grid", placeItems: "center", width: 42, height: 42, flexShrink: 0, borderRadius: "12px", color: "#30219C", border: "1px solid #DBD3FF", background: "linear-gradient(140deg, #F7F5FF, #EDE8FF)" }}><Icono sx={{ fontSize: 24 }} /></Box>
          <Box>
            <Typography component="h2" sx={{ color: "#100D36", fontSize: 20, fontWeight: 700 }}>{titulo || actual.titulo}</Typography>
            <Typography sx={{ color: "#3F4D70", fontSize: 12, mt: 0.15 }}>{ayuda || actual.ayuda}</Typography>
          </Box>
        </Box>
        {acciones && <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1.5 }}>{acciones}</Box>}
      </Box>
    </Box>
  );
}

CabeceraPasoEvento.propTypes = { paso: PropTypes.number.isRequired, acciones: PropTypes.node, titulo: PropTypes.string, ayuda: PropTypes.string, mostrarNumero: PropTypes.bool };
